import * as React from 'react';
import * as Yup from 'yup';
import { DialogTitle, TextField, Dialog, DialogContent, Button, DialogActions } from '@mui/material';
import { FastField, Formik } from 'formik';
import { DialogProps } from '@mui/material/Dialog';
import { VALID_SITE_NAME, SITE_NAME_HELPER } from './Websites';
import { FormikTextField } from '../FormikTextField';
import { notify } from '../../services/ui-dialog';

const dialogContentStyle: any = {
    minWidth: '300px'
}

type Props = {
    cloneDialogKey: string|null,
    cloneWebsite: (key: string, newKey: string)=> Promise<void>
} & DialogProps;

export class CloneSiteDialog extends React.Component<Props, {}>{

    private handleRenameSiteFormSubmit = async (values: any, { setSubmitting, resetForm }: any) => {
        try{
            await this.props.cloneWebsite(this.props.cloneDialogKey||'', values.name);
            setSubmitting(false);
            resetForm();
        }
        catch{
            setSubmitting(false);
            notify({ message: 'An error occurred while saving.', severity: 'error' });
        }
    }

    render(){

        const {cloneDialogKey, cloneWebsite, ...rest} = this.props;

        return (
            <Formik
                initialValues={{ name: '' }}
                onSubmit={this.handleRenameSiteFormSubmit}
                validationSchema={
                    Yup.object().shape({
                        name: Yup.string().matches(VALID_SITE_NAME, SITE_NAME_HELPER).required('Required.')
                    }).required()
                }>
                { props => {
                    const { handleSubmit, isSubmitting, submitForm } = props;
    
                    return (
                        <Dialog
                            {...rest}
                        >
                            <DialogTitle style={dialogContentStyle}>Clone Site</DialogTitle>
                            <DialogContent style={dialogContentStyle}>
                                <form onSubmit={handleSubmit}>
                                    <TextField
                                        fullWidth={true} margin="none" label="Clone From"
                                        value={this.props.cloneDialogKey||''} slotProps={{
                                        input: {readOnly:true}
                                    }} />
                                    <FastField autoFocus={true} margin="normal"
                                        debounce={15} name="name" label="New Website Name" component={FormikTextField} />
                                    <button disabled={isSubmitting} type="submit" onClick={submitForm}
                                        style={{width:1, height:1, visibility:'hidden'}}>Update</button>
                                </form>
                            </DialogContent>
                            <DialogActions>
                                <Button
                                    disabled={isSubmitting}
                                    color="primary"
                                    type="submit"
                                    value="rename"
                                    onClick={submitForm}>Clone</Button>
                            </DialogActions>
                        </Dialog>
                    );
                }}
            </Formik>
        );
    }
}